import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getFileById(fileid, userKey, clientKey, externalAccess) {
  validateUserKey(userKey);
  try {
    const requestData = { userKey, clientKey, externalAccess };
    const { data } = await apiClient.post(`api/file/${fileid}`, requestData);
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
